import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

export default () => {
	gsap.registerPlugin(ScrollTrigger);

	const items = document.querySelectorAll('[data-gsap]') as NodeListOf<HTMLElement>
	items?.forEach(item => {

		gsap.set(item, {
			y: 150,
			opacity: 0,
		});

		gsap.to(item, {
			y: 0,
			opacity: 1,
			scrollTrigger: {
				trigger: item,
				start: "-=150 bottom",
				end: "-=150 bottom",
				// markers: true,
			},
		})
	})
}
